module.exports = __webpack_public_path__ + "static/media/29ADMSPC31.f0b8d6e5.jpg";